import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import {
  WorksheetImagesAndRemarksSection,
  WorksheetResultsSection,
  WorksheetRootComponent,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import { PageSection } from '../../Layout';
import qestIds from '../QestIds';
import { MeasurementsSection, PreparationSection, ResultsSection } from './InHouseMethod/Sections';

let HandShearVaneWorksheet: WorksheetRootComponent = () => {
  return (
    <>
      <PageSection heading="Preparation">
        <PreparationSection />
      </PageSection>

      <PageSection heading="Measurements">
        <MeasurementsSection />
      </PageSection>

      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>

      <WorksheetResultsSection heading="Results">
        <ResultsSection />
      </WorksheetResultsSection>

      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

HandShearVaneWorksheet = withInjectedProps(HandShearVaneWorksheet);
HandShearVaneWorksheet.qestIds = [qestIds.handShearVane.InHouseMethod];

export default HandShearVaneWorksheet;
export { HandShearVaneWorksheet };
